module.exports = __webpack_public_path__ + "img/cju_gallery7.b50314e5.jpg";